<template>
  <div class="slideBox fans" :class="this.$route.query.source">

    <div class="slideHeader">
      <h1>
        <span class="source">{{ this.$route.query.sourceTitle }}</span>
        Entwicklung
      </h1>
    </div>

    <div class="layoutWrapper">
      <div class="layoutBox box1">

        <div class="total-value fans-total" :class="[totalValueEnd < 0 ? 'down' : 'up']">
          <div class="headlineBlock">
            <h2>Veränderung</h2>
            <h3>Anzahl Fans</h3>
          </div>
          <div class="big value">
            <i-count-up
              :start="0"
              :end="totalValueEnd"
              :decimals="1"
              :duration="countDuration"
              :options="options"
            ></i-count-up>
          </div>
          <div class="day">
            <span class="day-range-firstValue">Letzte 7 Tage</span>
            <span class="day-range-divider"></span>
            <span class="day-range-secondValue">7 Tage zuvor</span>
          </div>
        </div>

      </div>
      <div class="layoutBox box2">
        <div class="headlineBlock">
          <h2>Page likes</h2>
        </div>
        <div class="chartsBlock">
          <line-chart class="lineChart paidChart" v-if="dataPaid" :data="dataPaid" :height="100"></line-chart>
          <line-chart class="lineChart organicChart" v-if="dataOrganic" :data="dataOrganic" :height="100"></line-chart>
          <line-chart class="lineChart unlikesChart" v-if="dataUnlikes" :data="dataUnlikes" :height="100"></line-chart>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import _ from 'lodash'
import LineChart from '@/components/charts/line-chart'
import moment from 'moment'

export default {
  name: 'fans',
  components: {
    ICountUp,
    LineChart
  },
  data () {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      dataPaid: null,
      dataOrganic: null,
      dataUnlikes: null,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: ',',
        suffix: '%'
      }
    }
  },
  mounted () {
    const self = this
    const theme = this.$route.query.theme
    const source = this.$route.query.source
    const urlPart = theme + '-' + source + '_fans'

    /* total value */
    const totalValueURL = urlPart + '-last_7_days_vs_7_days_ago'
    this.axios.get(totalValueURL).then((response) => {
      this.totalValueEnd = parseFloat(_.head(response.data.results).percent.replace(',', '.'))
    })

    /* chart data */
    const chartDataURL = urlPart + '_page_likes-last_7_days'
    self.axios.get(chartDataURL).then((response) => {
      self.fillData(response.data.results)
    })
  },
  methods: {
    fillData (data) {
      const unlikes = []
      const paid = []
      const organic = []
      const days = []

      /* fill arrays */
      _.each(data, (entry) => {
        unlikes.push(parseInt(entry.unlike))
        paid.push(parseInt(entry.paid))
        organic.push(parseInt(entry.organic))
        days.push(moment(entry._time).locale('de').format('dd D'))
      })

      /* paid likes */
      this.dataPaid = {
        labels: days,
        datasets: [
          {
            pointBackgroundColor: '#fff',
            label: 'Bezahlt',
            backgroundColor: '#345895',
            data: paid
          }
        ]
      }

      /* organic likes */
      this.dataOrganic = {
        labels: days,
        datasets: [
          {
            pointBackgroundColor: '#fff',
            label: 'Organisch',
            backgroundColor: '#3cab3f',
            data: organic
          }
        ]
      }

      /* unlikes */
      this.dataUnlikes = {
        labels: days,
        datasets: [
          {
            pointBackgroundColor: '#fff',
            label: 'Unlikes',
            backgroundColor: '#ea0617',
            data: unlikes
          }
        ]
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/fans.vue